// extracted by mini-css-extract-plugin
export var printerCard = "_bt-1";
export var printerCardConfigured = "_bt-2";
export var printerCardError = "_bt-3";
export var printerCardsContainer = "_bt-0";
export var printerIcon = "_bt-8";
export var printerIconConfigured = "_bt-5";
export var printerIconContainer = "_bt-4";
export var printerIconError = "_bt-6";
export var printerIconUnconfigured = "_bt-7";
export var workstationsTableCard = "_bt-9";